// extracted by mini-css-extract-plugin
export default {"wrapper":"_832d4c8b","checkbox":"_ad1f8d2b","label":"_a895049e"};